/**
 * Object.entriesFrom() polyfill
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Object.fromEntries) {
  Object.fromEntries = function (entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error(
        'Object.fromEntries() requires a single iterable argument',
      )
    }
    // eslint-disable-next-line no-restricted-syntax
    return [...entries].reduce((obj, [key, val]) => {
      obj[key] = val
      return obj
    }, {})
  }
}
